import "../../utils/tailwind.css";
import { PageProvider, useQueryFormProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";

import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import { Form, Formik, FieldArray, Field } from "formik";
import { Accordion } from "react-bootstrap";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";

export default function QueryFormAdmin() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = useQueryFormProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values }) => (
          <Form>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-10 bg-white p-4 rounded-xl shadow-sm border border-gray-200">
              <div className="flex flex-col">
                <Label label="Main Heading (Black)" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="heading_black" rootClassName="w-full" placeholder="e.g. Let's Find the" />
              </div>
              <div className="flex flex-col">
                <Label label="Main Heading (Purple)" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="heading_purple" rootClassName="w-full" placeholder="e.g. Right Fit" />
              </div>
              <div className="flex flex-col">
                <Label label="Main Description" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="description" rootClassName="w-full" placeholder="e.g. Are you building a training program..." />
              </div>
            </div>

            <FieldArray name="paths">
              {({ push: pushPath, remove: removePath }) => (
                <div className="mb-8">
                  <div className="flex items-center justify-between gap-4 mt-3 mb-3">
                    <Button
                      type="button"
                      onClick={() => pushPath({ label: "", description: "", is_active: true, steps: [] })}
                      className="ml-auto !w-auto !text-xs flex items-center gap-2 !bg-[#7C13CA] text-white hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200 rounded-md px-4"
                    >
                      <Plus className="w-4 h-4" />
                      <span>Add User Type</span>
                    </Button>
                  </div>

                  <Accordion defaultActiveKey="0" className="mt-2">
                    {values.paths.map((path, pathIndex) => (
                      <Accordion.Item eventKey={pathIndex.toString()} key={pathIndex}>
                        <Accordion.Header>Plan: {path.label || `New User Type ${pathIndex + 1}`}</Accordion.Header>
                        <Accordion.Body>
                          <div className="flex justify-between items-center mb-4 pb-3 border-b">
                            <label className="flex items-center text-xs gap-2 cursor-pointer font-bold text-[#6A0BB0]">
                              <Field type="checkbox" name={`paths.${pathIndex}.is_active`} className="w-4 h-4 cursor-pointer" />
                              Active User Type
                            </label>

                            <Button type="button" onClick={() => removePath(pathIndex)} className="!bg-red-600 !w-auto !px-2 !text-xs !py-1 gap-1 flex items-center">
                              <Trash /> Delete this User Type
                            </Button>
                          </div>

                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div className="flex flex-col">
                              <Label label="Plan Label" className="mb-2 text-black text-[15px] font-semibold" />
                              <FormikInput name={`paths.${pathIndex}.label`} rootClassName="w-full" placeholder="e.g. I'm setting up employee training for my company" />
                            </div>
                            <div className="flex flex-col">
                              <Label label="Plan Description" className="mb-2 text-black text-[15px] font-semibold" />
                              <FormikInput name={`paths.${pathIndex}.description`} rootClassName="w-full" placeholder="e.g. HR team, L&D, corporate training, compliance" />
                            </div>
                          </div>

                          <Label label="Steps Configuration" className="mt-6 mb-3 text-black text-[16px] font-bold border-b pb-2" />

                          {/* STEPS ARRAY */}
                          <FieldArray name={`paths.${pathIndex}.steps`}>
                            {({ push: pushStep, remove: removeStep }) => (
                              <div className="space-y-4">
                                {path.steps && path.steps.map((step, sIndex) => (
                                  <div key={sIndex} className="p-4 border-2 border-gray-200 rounded-lg bg-gray-50/50">
                                    <div className="flex justify-between items-center mb-3">
                                      <h4 className="font-bold text-gray-800">Step {sIndex + 1}</h4>
                                      <Button type="button" onClick={() => removeStep(sIndex)} className="!bg-red-600 !text-white !w-auto !px-2 !text-xs !py-1 gap-1 flex items-center">
                                        <Trash /> Delete Step
                                      </Button>
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                                      <div className="flex flex-col">
                                        <Label label="Step Title" className="mb-1 text-black text-[13px] font-semibold" />
                                        <FormikInput name={`paths.${pathIndex}.steps.${sIndex}.title`} rootClassName="w-full" placeholder="e.g. Goals & Priorities" />
                                      </div>
                                      <div className="flex flex-col">
                                        <Label label="Step Description" className="mb-1 text-black text-[13px] font-semibold" />
                                        <FormikInput name={`paths.${pathIndex}.steps.${sIndex}.description`} rootClassName="w-full" placeholder="e.g. Help us understand what you need." />
                                      </div>
                                    </div>

                                    {/* QUESTIONS ARRAY INSIDE STEP */}
                                    <div className="pl-4 border-l-4 border-[#6A0BB0]">
                                      <Label label="Questions in this Step" className="mb-2 text-black text-[14px] font-bold" />
                                      <FieldArray name={`paths.${pathIndex}.steps.${sIndex}.questions`}>
                                        {({ push: pushQuestion, remove: removeQuestion }) => (
                                          <div className="space-y-3">
                                            {step.questions && step.questions.map((question, qIndex) => (
                                              <div key={qIndex} className="bg-white p-3 rounded-md border shadow-sm">
                                                <div className="flex justify-between items-start mb-2">
                                                  <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-2">
                                                    <FormikInput name={`paths.${pathIndex}.steps.${sIndex}.questions.${qIndex}.id`} rootClassName="w-full" placeholder="Field ID (e.g. training_needs)" />
                                                    <FormikInput name={`paths.${pathIndex}.steps.${sIndex}.questions.${qIndex}.title`} rootClassName="w-full" placeholder="Question Title" />

                                                    <div className="w-full">
                                                      <Field as="select" name={`paths.${pathIndex}.steps.${sIndex}.questions.${qIndex}.type`} className="w-full border border-gray-300 rounded-lg h-[40px] px-3 outline-none text-sm bg-white">
                                                        <option value="radio">Radio Buttons (Single Choice)</option>
                                                        <option value="checkbox">Checkboxes (Multiple Choice)</option>
                                                        <option value="text">Text Input (Short)</option>
                                                        <option value="textarea">Textarea (Long)</option>
                                                      </Field>
                                                    </div>
                                                  </div>
                                                  <Trash className="ml-3 mt-2 cursor-pointer text-red-500 flex-shrink-0" onClick={() => removeQuestion(qIndex)} />
                                                </div>

                                                {['radio', 'checkbox'].includes(question.type) && (
                                                  <div className="mt-2 pt-2 border-t border-gray-100">
                                                    <Label label="Options" className="mb-1 text-black text-[12px] font-bold" />
                                                    <FieldArray name={`paths.${pathIndex}.steps.${sIndex}.questions.${qIndex}.options`}>
                                                      {({ push: pushOption, remove: removeOption }) => (
                                                        <div className="flex flex-col gap-2">
                                                          {question.options && question.options.map((opt, optIndex) => (
                                                            <div key={optIndex} className="flex items-center gap-3">
                                                              <FormikInput name={`paths.${pathIndex}.steps.${sIndex}.questions.${qIndex}.options.${optIndex}`} rootClassName="flex-1" placeholder="Option text (e.g. 1-50 employees)" />
                                                              <Trash className="cursor-pointer text-red-500 flex-shrink-0" onClick={() => removeOption(optIndex)} />
                                                            </div>
                                                          ))}
                                                          <div className="flex items-center gap-2 mt-1 cursor-pointer text-[#7C13CA] font-semibold" onClick={() => pushOption("")}>
                                                            <div className="bg-[black] p-1 rounded-full w-auto">
                                                              <Plus className="text-[white] " />
                                                            </div>
                                                            <span className="text-xs">Add Option</span>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </FieldArray>
                                                  </div>
                                                )}

                                                {['text', 'textarea'].includes(question.type) && (
                                                  <div className="mt-2 pt-2 border-t border-gray-100">
                                                    <div className="flex flex-col">
                                                      <Label label="Input Placeholder" className="mb-1 text-black text-[13px] font-semibold" />
                                                      <FormikInput
                                                        name={`paths.${pathIndex}.steps.${sIndex}.questions.${qIndex}.placeholder`}
                                                        rootClassName="w-full"
                                                        placeholder={question.type === 'textarea' ? "Enter your Description placeholder. e.g. Describe your vision here..." : "Enter your Input placeholder. e.g. Enter your name"}
                                                      />
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            ))}

                                            <Button
                                              type="button"
                                              onClick={() => pushQuestion({ id: "", title: "", type: "radio", options: [] })}
                                              className="mt-2 !w-auto flex items-center gap-2 !bg-gray-800 !text-xs text-white hover:!bg-black transition-colors duration-200 rounded-md px-2 py-1"
                                            >
                                              <Plus />
                                              <span>Add Question</span>
                                            </Button>
                                          </div>
                                        )}
                                      </FieldArray>
                                    </div>
                                  </div>
                                ))}

                                <Button
                                  type="button"
                                  onClick={() => pushStep({ id: "", title: "", description: "", questions: [] })}
                                  className="mt-3 !w-auto flex items-center gap-2 !bg-[#7C13CA] text-white hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200 rounded-md px-4"
                                >
                                  <Plus className="w-4 h-4" />
                                  <span>Add Step</span>
                                </Button>
                              </div>
                            )}
                          </FieldArray>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              )}
            </FieldArray>

            <div className="mt-8 mb-20 bg-white p-4 rounded-xl shadow-sm border border-gray-200 overflow-x-auto">
              <Label label="Final Step: Contact Fields Configuration" className="mb-4 text-black text-[16px] font-bold border-b pb-2" />
              <FieldArray name="contact_fields">
                {({ push: pushContactField, remove: removeContactField }) => (
                  <div className="space-y-3 min-w-[1000px]">
                    <div className="grid grid-cols-12 gap-3 px-3 py-2 bg-gray-100 rounded-t-lg font-semibold text-sm border-b">
                      <div className="col-span-2">Field ID</div>
                      <div className="col-span-2">Field Name</div>
                      <div className="col-span-2">Placeholder</div>
                      <div className="col-span-2">Initial Value</div>
                      <div className="col-span-1">Group</div>
                      <div className="col-span-1">Type</div>
                      <div className="col-span-1 text-center">Required</div>
                      <div className="col-span-1 text-center">Action</div>
                    </div>
                    {values.contact_fields && values.contact_fields.map((field, fieldIndex) => (
                      <div key={fieldIndex} className="grid grid-cols-12 gap-3 items-center px-3 py-2 border-b last:border-b-0 hover:bg-gray-50">
                        <div className="col-span-2">
                          <FormikInput name={`contact_fields.${fieldIndex}.id`} rootClassName="w-full" placeholder="e.g. full_name" />
                        </div>
                        <div className="col-span-2">
                          <FormikInput name={`contact_fields.${fieldIndex}.label`} rootClassName="w-full" placeholder="e.g. Full Name" />
                        </div>
                        <div className="col-span-2">
                          <FormikInput name={`contact_fields.${fieldIndex}.placeholder`} rootClassName="w-full" placeholder="e.g. Enter your name" />
                        </div>
                        <div className="col-span-2">
                          <FormikInput name={`contact_fields.${fieldIndex}.initial_value`} rootClassName="w-full" placeholder="Optional" />
                        </div>
                        <div className="col-span-1">
                          <FormikInput name={`contact_fields.${fieldIndex}.group`} rootClassName="w-full" placeholder="Group" />
                        </div>
                        <div className="col-span-1">
                          <Field as="select" name={`contact_fields.${fieldIndex}.type`} className="w-full border border-gray-300 rounded-lg h-[40px] px-2 outline-none text-xs bg-white">
                            <option value="text">Text</option>
                            <option value="email">Email</option>
                            <option value="number">Number</option>
                          </Field>
                        </div>
                        <div className="col-span-1 flex justify-center">
                          <Field type="checkbox" name={`contact_fields.${fieldIndex}.is_required`} className="w-4 h-4 cursor-pointer" />
                        </div>
                        <div className="col-span-1 flex justify-center">
                          <Trash className="cursor-pointer text-red-500 hover:text-red-700 transition-colors" onClick={() => removeContactField(fieldIndex)} />
                        </div>
                      </div>
                    ))}

                    <Button
                      type="button"
                      onClick={() => pushContactField({ id: "", label: "", placeholder: "", initial_value: "", type: "text", is_required: true, group: "YOUR INFORMATION" })}
                      className="mt-4 !w-auto flex items-center gap-2 !bg-[#7C13CA] text-white hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200 rounded-md px-4 py-2"
                    >
                      <Plus className="w-4 h-4" />
                      <span>Add Row</span>
                    </Button>
                  </div>
                )}
              </FieldArray>
            </div>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200 px-5"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
